import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { WhatsNewEntryType } from './whats-new-entry-type';

export type WhatsNewEntryId = WhatsNewEntry['id'];

export type WhatsNewEntry = z.output<typeof whatsNewEntrySchema>;
export type WhatsNewEntryDTO = z.input<typeof whatsNewEntrySchema>;

export const whatsNewEntrySchema = z.object({
  id: z.uuid(),
  createdAt: isoDatetimeToDate,
  updatedAt: isoDatetimeToDate,
  title: z.string(),
  subtitle: z.string(),
  message: z.string(),
  link: z.url().nullable(),
  linkTitle: z.string().nullable(),
  createdBy: z.string(),
  type: z.enum(WhatsNewEntryType),
  read: z.boolean(),
});
